import React, { Component } from 'react';
import Select from 'react-select';
import { Grid, Row, Col, Panel, Button, Tabs, Tab, ButtonToolbar, Breadcrumb, Input } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { Toolbar, Data } from 'react-data-grid-addons';
import ReactDataGrid from 'react-data-grid';
import axios from 'axios';
import { ROOT_URL } from '../../actions/root_url';
import moment from 'moment';
import CashFormatter from '../Common/cashFormatter';

const { Selectors } = Data;

export class WIZPODModal extends Component {
    constructor() {
        super();
        this.state = {
            rows: [],
            selectedRows: null,
            editedRows: [],
            filters: {},
            sortColumn: null,
            sortDirection: null,

            details: {
                rows: [],
                selectedRows: null,
                editedRows: [],
                filters: {},
            },
        }
    }

    componentDidMount() {        
        // this.props.fetchFJAgents(this.props.fjCustomerId).then((response) => {
        //     if (response.data) {
        //         this.initializeModal(response.data);
        //     }
        // }, (err) => {
        //     if (err.status === 500 || err.status === 404) {
        //         alert("Server error, please refresh page. If problem persists, contact administrator.");
        //     }
        // });

        this.wizfetchblah();

        // let url = `${ROOT_URL}v2/sales/pod/${this.props.singleSalesOrderId}/`;
        // axios({
        //     method: 'GET',
        //     url: url,
        //     headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        // })
        //     .then(res => {
        //         this.setState({
        //             rows: res.data,
        //             selectedRows: [],
        //             editedRows: [],
        //         });
        //     }, err => {
        //     })
    }

    wizfetchblah() {
        let url = `${ROOT_URL}v2/sales/pod/${this.props.singleSalesOrderId}/`;
        axios({
            method: 'GET',
            url: url,
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        })
            .then(res => {
                this.setState({
                    rows: res.data,
                    selectedRows: [],
                    editedRows: [],
                });
            }, err => {
            })
    }

    deletePOD(value) {
        let url = `${ROOT_URL}v2/sales/pod/${value}/`;
        axios({
            method: 'DELETE',
            url: url,
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        })
            .then(res => {
                alert("POD Deleted.");
               this.wizfetchblah();
            }, err => {
            })
    }

    componentWillReceiveProps(nextProps) {
    }

    // initializeModal = (array) => {
    //     let index = 0;
    //     let formatter = [];
    //     if (array && array.length > 0) {
    //         array.map(r => {
    //             formatter.push({ Idx: index++, customer: r.customer, id: r.id, name: r.name, note: r.note, ref_num: r.ref_num });
    //         })
    //     } else {
    //         formatter.push({ Idx: 0, name: "", note: "" });
    //     }
    //     this.setState({
    //         rows: formatter,
    //         selectedRows: [],
    //         editedRows: [],
    //     });
    // }

    handleOnSave = (e) => {
        e.preventDefault();
        this.state.rows.map((r) => {
            // r.recreate = false;
        });
        if (this.state.selectedRows.length < 1) {
            alert("At least one product is required.");
            return;
        }
        let tempArray = [];
        let tempString = "";
        if (this.state.selectedRows && this.state.selectedRows.length > 0) {
            this.state.selectedRows.map(r=> {
                tempArray.push(r.SalesOrderLine_id);
            });
            tempString = tempArray.join(',');
        }
        this.props.printSalesOrderLabelDSQ(tempString);
        // this.props.updateFJAgents(this.props.fjCustomerId, this.state.rows).then((response) => {
        //     // alert(JSON.stringify(response.data));
        //     alert("Agents Saved");
        //     this.props.closeAgentModal();
        //   }, (err) => {
        //     if (err.status === 500 || err.status === 404) {
        //       alert(JSON.stringify(err.data));
        //     }
        //   });
        // this.props.onSave(this.state.rows);
    }



    // clickNew(e) {
    //     e.preventDefault();
    //     let rows = Selectors.getRows(this.state);
    //     let index = rows.length;
    //     let newRow = { name: null, note: null, customer: this.props.fjCustomerId, Idx: index };
    //     rows.push(newRow);
    //     let editedRows = [...this.state.editedRows];
    //     editedRows.push(newRow)
    //     this.setState({ rows, editedRows })
    // }

    deleteCategory(e) {
        e.preventDefault();
        let rows = [...this.state.rows];
        let editedRows = [...this.state.editedRows];
        let index = _.findIndex(rows, { Idx: this.state.selectedRows[0].Idx })

        if (this.state.selectedRows[0].id) {
            // this.props.deleteFJAgents(this.state.selectedRows[0].id).then((response) => {
            //     alert("Agent Deleted");
            //     rows.splice(index, 1);
            //     index = _.findIndex(editedRows, { Idx: this.state.selectedRows[0].Idx })
            //     editedRows.splice(index, 1);
            //     this.setState({ rows, editedRows, selectedRows: [] })
            //     // this.props.fetchFJAgents(this.props.fjCustomerId).then((response) => {
            //     //     if (response.data) {
            //     //         this.initializeModal(response.data);
            //     //     }
            //     // }, (err) => {
            //     //     if (err.status === 500 || err.status === 404) {
            //     //         alert("Server error, please refresh page. If problem persists, contact administrator.");
            //     //     }
            //     // });
            // }, (err) => {
            //     if (err.status === 500 || err.status === 404 || err.status === 405) {
            //         alert("Error cannot delete agent.");
            //     }
            // });
        }

        // rows.splice(index, 1);
        // index = _.findIndex(editedRows, { Idx: this.state.selectedRows[0].Idx })
        // editedRows.splice(index, 1);
        // this.setState({ rows, editedRows, selectedRows: [] })
    }

    renderAgentTable() {
        const getRows = () => {
            return Selectors.getRows(this.state);
        }
        const getSize = () => {
            return getRows().length;
        }
        const rowGetter = rowIdx => {
            var rows = getRows();
            return rows[rowIdx];
        }
        const handleRowUpdated = e => {
            this.setState({ sortColumn: null, sortDirection: null })
            let rows = getRows();
            let editedRows = this.state.editedRows.slice(0);
            Object.assign(rows[e.rowIdx], e.updated);
            editedRows.forEach((element, index) => {
                if (element.Idx === rows[e.rowIdx].Idx)
                    editedRows.splice(index, 1)
            }, this);
            editedRows.push(rows[e.rowIdx]);
            this.setState({
                rows: rows,
                editedRows: editedRows,
            });
        }
        // const onRowsSelected = (rows) => {
        //     let newRows = getRows();
        //     newRows.map(r => {
        //         r.isSelected = false;
        //     })
        //     rows.map(r => {
        //         newRows[r.rowIdx].isSelected = true;
        //     });
        //     this.setState({ rows: newRows, selectedRows: [rows[0].row] });
        // }
        const onRowsSelected = (rows) => {
            let newRows = getRows();
            let selectedRows = [...this.state.selectedRows];
            rows.map(r => {
                newRows[r.rowIdx].isSelected = true;
                selectedRows.push(r.row);
            });
            this.setState({ rows: newRows, selectedRows });
        }
        // const onRowsDeselected = (rows) => {
        //     let newRows = getRows();
        //     rows.map(r => {
        //         newRows[r.rowIdx].isSelected = false;
        //     });
        //     this.setState({ rows: newRows, selectedRows: [] });
        // }
        const onRowsDeselected = (rows) => {
            let newRows = [...this.state.rows];
            let selectedRows = [...this.state.selectedRows];
            rows.map((r) => {
                newRows[r.rowIdx].isSelected = false;
                const rowIndex = selectedRows.indexOf(r.row);
                selectedRows.splice(rowIndex, 1);
            });
            this.setState({ rows: newRows, selectedRows });
        }

        const handleGridSort = (sortColumn, sortDirection) => {
            var state = Object.assign({}, this.state, { sortColumn: sortColumn, sortDirection: sortDirection });
            this.setState(state);
          }

        const handleFilterChange = filter => {
            let newFilters = Object.assign({}, this.state.filters);
            if (filter.filterTerm) {
              newFilters[filter.column.key] = filter;
            } else {
              delete newFilters[filter.column.key];
            }
            this.setState({ filters: newFilters });
          }

        const SecondsDateFormatter = React.createClass({
            render() {
              if (this.props.value) {
                const date = moment(this.props.value).format("MM-DD-YY HH:mm");
                return <span>{date}</span>;
              }
              return <span className="label label-danger">-</span>;
            },
          });

        const columns = [
            // {
            //   key: "ContainerNum",
            //   name: <Translate value="container_num" />,
            //   resizable: true,
            //   sortable: true,
            //   width: 100,
            // },
            {
                key: "filename",
                name: <Translate value="file_name" />,
                resizable: true,
                sortable: true,
                width: 180,
                filterable: true,
              },
              {
                key: "description",
                name: <Translate value="desc" />,
                resizable: true,
                sortable: true,
                width: 180,
                filterable: true,
              },
              {
                key: "url",
                name: <Translate value="download" />,
                resizable: true,
                sortable: true,
                width: 160,
                formatter: ({ value }) => (
                  <div
                    style={{ width: '100%', height: '100%' }}
                  //   onClick={() => {
                  //    console.log("1");
                  //   }}
                  >
                    <a href={value}><Translate value="download" /></a>
                  </div>
                ),
              },
              {
                key: "id",
                name: <Translate value="delete_double" />,
                resizable: true,
                sortable: true,
                width: 130,
                formatter: ({ value }) => (
                  <div
                    style={{ width: '100%', height: '100%' }}
                    // onClick={() => {
                    //  this.deletePOD(value);
                    // }}
                  >
                      <p style={{color: 'red', margin: '0px', cursor: 'pointer'}} onDoubleClick={()=>{ this.deletePOD(value) }}><Translate value="delete" /></p>
                  </div>
                ),
              },

        
          ];

        const onRowClick = (rowIdx, row) => {
            if (rowIdx !== -1) {
              const rows = getRows();
              rows.map((r) => {
                r.isSelected = false;
              });
              const selectedRows = [rows[rowIdx]];
              rows[rowIdx].isSelected = true;
            //   const salesOrders = { ...this.state.salesOrders, rows, selectedRows };
            //   this.setState({ salesOrders });
            //   this.props.fetchSalesOrderDetail(row.SalesOrder_id, route);
            let temp = {
                rows: [],
                selectedRows: null,
                editedRows: [],
                filters: {},
            };
              if (selectedRows && selectedRows[0]) {
                temp.rows = selectedRows[0].lines;
                this.setState({ details: temp });
              }
            }
          };

        return (
            <Row>
                <Col>
                    {/* <div style={{ maxWidth: '550px', marginLeft: '25px' }}> */}
                    {/* <div style={{marginTop: "100px"}}> */}
                    <div>
                        <ReactDataGrid
                            // rowKey="Idx"
                            // enableCellSelect={true}
                            onGridSort={handleGridSort}
                            onAddFilter={handleFilterChange}
                            columns={columns}
                            rowGetter={rowGetter}
                            rowsCount={getSize()}
                            minHeight={350}
                            rowHeight={25}
                            headerRowHeight={45}
                            toolbar={<Toolbar enableFilter />}
                            // enableRowSelect='single'
                            onRowUpdated={handleRowUpdated}
                            // rowSelection={{
                            //     showCheckbox: true,
                            //     onRowsSelected,
                            //     onRowsDeselected,
                            //     selectBy: {
                            //         isSelectedKey: 'isSelected'
                            //     }
                            // }}
                            // onRowClick={onRowClick}
                        />
                    </div>
                </Col>
            </Row>
        )
    }

////////////
////////////////////////////////////////////////////////////////////////
////////////
    renderDetailTable() {
        const getRows = () => {
            return Selectors.getRows(this.state.details);
        }
        const getSize = () => {
            return getRows().length;
        }
        const rowGetter = rowIdx => {
            var rows = getRows();
            return rows[rowIdx];
        }

        const columns = [
            {
                key: 'sku',
                name: 'SKU',
                resizable: true,
                sortable: true,
                filterable: true,
                width: 150,
            },
            {
                key: 'fba',
                name: 'FBA',
                resizable: true,
                sortable: true,
                filterable: true,
                width: 120,
            },
            // {
            //     key: 'prod_name',
            //     name: <Translate value="product_name" />,
            //     resizable: true,
            //     sortable: true,
            //     filterable: true,
            //     width: 200,
            // },
            {
                key: 'quantity',
                name: <Translate value="quantity" />,
                resizable: true,
                sortable: true,
                filterable: true,
                width: 100,
            },
            {
                key: 'note',
                name: <Translate value="note" />,
                resizable: true,
                sortable: true,
                filterable: true,
                width: 250,
            },
        ]

        return (
            <Row>
                <Col>
                    {/* <div style={{ maxWidth: '550px', marginLeft: '25px' }}> */}
                    <div>
                        <ReactDataGrid
                            // rowKey="Idx"
                            enableCellSelect={true}
                            columns={columns}
                            rowGetter={rowGetter}
                            rowsCount={getSize()}
                            minHeight={140}
                            rowHeight={25}
                            headerRowHeight={45}
                            // enableRowSelect='single'
                            // rowSelection={{
                            //     showCheckbox: true,
                            //     onRowsSelected,
                            //     onRowsDeselected,
                            //     selectBy: {
                            //         isSelectedKey: 'isSelected'
                            //     }
                            // }}
                        />
                    </div>
                </Col>
            </Row>
        )
    }

    render() {
        const {
        } = this.props;

        const {
        } = this.state;

        return (
            <div>
                {/* <ButtonToolbar style={{ marginLeft: '5px', marginBottom: '7px' }}>
                    <Button
                        bsStyle="primary"
                        onClick={(event) => { this.clickNew(event) }}
                    >
                        <em className="fa fa-plus marginRightStyle" /><Translate value="add" />
                    </Button>
                    <Button
                        style={{ marginRight: '5px' }}
                        bsStyle="danger"
                        onClick={(event) => { this.deleteCategory(event) }}
                        disabled={!this.state.selectedRows || this.state.selectedRows.length != 1}
                    ><em className="fa fa-trash marginRightStyle" /><Translate value="delete" />
                    </Button>
                </ButtonToolbar> */}
                <Row>
                    <Col className="text-center">
                        <div style={{padding: '0px 25px'}}>
                            {this.renderAgentTable()}
                        </div>
                    </Col>
                </Row>
{/* 
                <Row>
                <p style={{padding: '0px 25px', fontWeight: 'bold', fontSize: '18px', marginTop: '5px', marginBottom: '0px' }}>
                  <Translate value="details" />
                </p>
                    <Col className="text-center">
                        <div style={{padding: '0px 25px'}}>
                            {this.renderDetailTable()}
                        </div>
                    </Col>
                </Row> */}

                <Row className="centerStyle" style={{ marginTop: '15px' }}>
                    <Button
                        style={{ marginRight: '5px' }}
                        bsStyle="success"
                        onClick={() => {
                            this.refs.msoCreateInputRef4.click();
                          }}
                    >
                        <em className="fa fa-print" />
                        <Translate value="upload_pod" />
                    </Button>



                    <input
                          type="file"
                          style={{ display: "none" }}
                          onClick={(e)=> {
                            e.target.value = null;
                              }}
                          onChange={(e) => {
                            let wURL = `${ROOT_URL}v2/sales/pod/${this.props.singleSalesOrderId}/`;
                            const formData = new FormData();
                            formData.append("FILE", e.target.files[0]);
                            if (e.target.files[0]) {
                              axios
                                .post(
                                  wURL,
                                  formData,
                                  {
                                    headers: {
                                      Authorization: `Bearer ${localStorage.getItem(
                                        "token"
                                      )}`,
                                    },
                                  },
                                )
                                .then(
                                  (res) => {
                                    alert("POD uploaded successfully");
                                    this.wizfetchblah();
                                    // this.fetchSalesOrdersByDetails(
                                    //   this.state.days
                                    // );
                                  },
                                  (err) => {
                                    if (err.data) {
                                      alert(err.data);
                                    } else {
                                      alert("Server issue detected, please contact admin.");
                                    }
                                  }
                                );
                            }
                          }}
                          ref="msoCreateInputRef4"
                        />


                    {/* <Button
                        style={{ marginRight: '5px' }}
                        bsStyle="success"
                        onClick={(e) => { this.handleOnSavePrint(e); }}
                    >
                        <Translate value="save_and_print" />
                    </Button> */}
                    {/* <Button
                        bsStyle="success"
                        onClick={(e) => { this.handleOnRecreate(e); }}
                        disabled={!this.state.selectedRows || this.state.selectedRows.length < 1}
                    >
                        <Translate value="recreate" />
                    </Button> */}
                </Row>
            </div>
        );
    }
}

export default WIZPODModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/wizPODModal.jsx